<template>
  <v-app class="home-page" :key="updateLanguage">
    <header-comp
      :activeButton="0"
      :userInfo="this.dealersData"
      access="admin"
      v-on:update="onStep1Update"
    />
    <v-switch
      class="switch-fixed"
      color="primary"
      :v-model="solarSwitch.value"
      :value="solarSwitch.value"
      :loading="solarSwitch.loading"
      :disabled="solarSwitch.disable"
      :label="'lng_solar_switch_label_txt' | translate"
      @change="filterSolarUsers"
    ></v-switch>
    <v-tabs v-model="activeTab" centered @change="changeTab">
      <v-tab>{{ "lng_users_map_view_txt" | translate }}</v-tab>
      <!-- <v-tab v-if="authLevel==3">{{ "lng_dealers_list_view_txt" | translate }}</v-tab> -->
      <v-tab>{{ "lng_users_list_view_txt" | translate }}</v-tab>
    </v-tabs>
    <div v-if="activeTab === 0" class="map-container">
      <AdminSystemsMap
        mapType="users"
        :solarOption="solarSwitch"
        :systemData="dealerUsers"
        :mapCentered="mapCentered"
        @markerClicked="dealerMarkerClicked"
      />
    </div>
    <div v-if="activeTab === 1" class="my-2">
      <v-row class="m-1" v-if="dealerDashbaord">
        <v-col v-if="false" cols="12" xs="12" sm="6" md="3" class="pa-2">
          <v-card>
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-title class="headline mb-1">
                  {{ dealerDashbaord['total-dealers'] }}</v-list-item-title>
                <v-list-item-subtitle>{{ "lng_total_dealers_txt" | translate }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
      </v-row>
      <div class="ma-5">
        <input type="text" v-model="searchUser" class="search-filter" :placeholder="'lng_search_txt' | translate">
      </div>
      <v-card class="ma-3">
        <v-card-title style="background: gainsboro;">
          {{ "lng_users_list_view_txt" | translate }}
          <v-spacer></v-spacer>
          <v-btn v-if="authLevel === '3'" class="mx-2" fab dark small color="#0B7894" @click="openFiltersModal = true; userTypeFilter=true;">
            <v-icon dark>mdi-filter</v-icon>
          </v-btn>
          <!-- <v-tooltip left v-if="authLevel === '3'">
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="mx-2" @click="openEditUserModal=true; editUserModalKey += 1; selectedUser={}; editOrCreateType='create'"
              fab dark small color="#0B7894" v-bind="attrs" v-on="on">
                <v-icon dark>mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>{{ "lng_create_new_user_txt" | translate }}</span>
          </v-tooltip> -->
        </v-card-title>
        <v-col v-if="dealerUsers" cols="12" style="overflow: auto;" class="pa-0">
          <v-data-table
            :headers="dealerTableHeaders"
            :items="filterSearchUser"
            class="elevation-1"
            :footer-props="{
              itemsPerPageText: translateRowPrPage
            }"
          >
            <template v-slot:item.email="{ item }">
              <span style="cursor: pointer;" @click="dealerMarkerClicked(item)">{{ item.email }}</span>
            </template>
            <template v-slot:item.full_address="{ item }">{{ item.address1 }} {{ item.zip }} {{ item.city }}</template>
            <template v-slot:item.userType="{ item }">
              <userRoles :roleKey="item.authlevel" templateType="chip"/>
            </template>
            <template v-slot:item.companyname="{ item }"> {{ decodeHtml(item.companyname) }}</template>
            <template v-slot:item.name="{ item }"> {{ decodeHtml(item.name) }}</template>
            <!-- <template v-slot:item.action="{ item }">
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="mx-2" @click="openEditUserModal=true; editUserModalKey += 1; selectedUser=item; editOrCreateType='edit'"
                  fab x-small v-bind="attrs" v-on="on">
                    <v-icon dark>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>{{ "lng_edit_txt" | translate }} {{ getTextBasedOnRoles(item) }}</span>
              </v-tooltip>
            </template> -->

          </v-data-table>
        </v-col>
      </v-card>
    </div>
    <SystemInfoModal
      :changeKey="infoModalKey"
      :dealer-token="adminToken"
      :dialog-title="'lng_box_detail_key_txt' | translate"
      :system-data="systemItem"
      :all-dealers="dealerUsers"
      :openDialog="openInfoModal"
      :closeDialog="closeInfoModalFunc"
      :employee-data="employeesData"
    ></SystemInfoModal>
    <AddSystem
      :dealer-token="adminToken"
      :dialog-title="'lng_add_system_toDealer_txt' | translate"
      :openDialog="openAddSystemModal"
      :closeDialog="closeAddSystemModalFunc"
    />
    <FiltersDialog
      :dealer-token="adminToken"
      :dialog-title="'lng_choose_filters_txt' | translate"
      :openDialog="openFiltersModal"
      :userTypeFilter="userTypeFilter"
      :closeDialog="closeFiltersModalFunc"
      @applyFilters="applyFilters"
    />
    <DealerInfoModal
      :admin-token="adminToken"
      :dialog-title="'lng_user_detail_txt' | translate"
      :dealer-data="dealerItem"
      :openDialog="openDealerInfoModal"
      :closeDialog="closeDealerInfoModalFunc"
      :systemData="systemData"
      @selectUser="selectedUserFromMap(dealerItem)"
    ></DealerInfoModal>
    <CreateEditUser
      :changeKey="editUserModalKey"
      :editOrCreateType="editOrCreateType"
      :user-data-prop="selectedUser"
      :openDialog="openEditUserModal"
      :closeDialog="closeEditUserModalFunc"
      @refreshUsers="fetchDealersInfo(adminToken)"
    />
    <AlterServiceDate
      :openDialog="openAlterDateModal"
      :systemData="singleSystemData"
      :closeDialog="closeAlterServiceDateFunc"
      @refreshSystemsData="fetchUserSystems(adminToken)"
    />
    <AssignSystemItself 
      :user-token="adminToken"
      :openDialog="openAssignItselfToggle"
      :closeDialog="closeAssignItselfModalFunc"
      @updateLocalData="fetchUserSystems(adminToken)"
    />
    <EventItems
      :dialog-title="'lng_menu_eventlogs' | translate"
      :openDialog="openEventsModal"
      :closeDialog="closeEventsModalFunc"
      :systemId="selectedSystemId"
      :userToken="adminToken"
    />
  </v-app>
</template>

<script>
// @ is an alias to /src
import Menu from "../components/Menu.vue";
import L from "leaflet";
import GlobalService from "../services/global-service";
import HeaderComp from "../components/HeaderComp";
import { translateFunc } from "../common/Filters.js"
import { getTextBasedOnRoles, decodeHtml } from "../common/HelperFunctions"
import { centerLocations } from "../common/Constant"
import AddSystem from "../components/dealer/AddSystem"
import FiltersDialog from "../components/admin/FiltersDialog"
import DealerInfoModal from "../components/admin/DealerInfoModal"
import UserRoles from "../components/admin/UserRoles";
import moment from "moment";
import AdminSystemsMap from "../components/admin/AdminSystemsMap";
import CreateEditUser from "../components/admin/CreateEditUser";
import SystemInfoModal from "../components/admin/SystemInfoModal"
import filterSearchSystem from "../mixins/SearchFilter"
import filterSearchUser from "../mixins/SearchFilter"
import onStep1Update from "../mixins/ChangeLanguage"
import AlterServiceDate from "../components/admin/AlterServiceDate.vue"
import AssignSystemItself from "../components/dealer/AssignSystemItself.vue"
import EventItems from "../components/admin/EventItems.vue"
import { solarRoleIds } from "../common/Constant"


export default {
  name: "Dealers",
  components: {
    Menu,
    HeaderComp,
    AddSystem,
    FiltersDialog,
    DealerInfoModal,
    UserRoles,
    AdminSystemsMap,
    CreateEditUser,
    SystemInfoModal,
    AlterServiceDate,
    AssignSystemItself,
    EventItems
  },
  data() {
    return {
      searchUser:'',
      searchSystem:'',
      adminToken: undefined,
      authLevel: undefined,
      systemData: undefined,
      singleSystemData: undefined,
      systemItem: {},
      activeTab: 0,
      employeesData:undefined,
      dealerTableHeaders: [
        { width: '120px', text: translateFunc('lng_th_user_type_txt'), value: 'userType', sortable: false, },
        { width: '120px', text: translateFunc('lng_th_email_txt'), value: 'email' },
        // { width: '200px', text: translateFunc('lng_th_name_txt'), value: 'name' },
        { width: '200px', text: translateFunc('lng_th_companyName_txt'), value: 'companyname' },
        { width: '100px', text: translateFunc('lng_th_cvr_txt'), value: 'cvr' },
        { width: '250px', text: translateFunc('lng_th_address_txt'), value: 'full_address' },
        { width: '100px', text: translateFunc('lng_th_zip_code_txt'), value: 'zip' },
        { width: '100px', text: translateFunc('lng_th_country_txt'), value: 'country' },
        { width: '100px', text: translateFunc('lng_th_phone_txt'), value: 'phonenumber' },
        // { width: '120px', text: translateFunc('lng_th_lastActive_txt'), value: 'lastlogin' },
        // { width: '120px', text: translateFunc('lng_th_actions'), value: 'action', sortable: false },
      ],
      listLoading: false,
      dealerDashbaord: undefined,
      filteredData: undefined,
      originalDealersData: undefined,
      dealersData: undefined,
      dealerUsers: undefined,
      filteredDealerUsers: undefined,
      dealerItem: {},
      assignedUsers: [],
      selectedUser: {},
      editOrCreateType: 'create',

      openInfoModal: false,
      infoModalKey: 1,
      openAddSystemModal: false,
      openDealerInfoModal: false,
      openFiltersModal: false,
      openEditUserModal: false,
      editUserModalKey: 1,
      userTypeFilter: false,
      openAlterDateModal: false,
      openAssignItselfToggle: false,
      selectedSystemId: null,
      openEventsModal: false,
      mapCentered: {},
      solarSwitch: {
        value: false,
        disable: false,
        loading: false
      }
    };
  },
  computed: {
    translateRowPrPage(){
      return translateFunc('lng_rows_perpage_txt')
    },
  },
  mounted() {
    this.chooseDefaultsFromURL()
    let token = sessionStorage.getItem("userToken");
    this.authLevel = sessionStorage.authLevel;
    // let token = "0923bf24d543bc0f1e9a3a091efc7345d4f1c85cde7f896e9d572d6e5b91529047d17b05f9be03287973b81fd8e84d4edacfa7a95fba546c6505a5860780c1cd";
    this.adminToken = token;
    
    this.listLoading = true;
    this.fetchDealerUsers(token ? token : "anonymous")
    // this.fetchDealersInfo(token);
    // this.fetchUserSystems(token);
    // this.fetchDashboardInfo(token);
    // this.fetchEmployeesList(token);

    // this.fetchDealerUsers(token);
  },
  mixins:[filterSearchSystem, filterSearchUser, onStep1Update],

  methods: {
    filterSolarUsers(val) {
      this.solarSwitch = {
        value: val,
        disable: true,
        loading: 'warning'
      };
      let newFilteredData = [];
      if(this.dealerUsers && this.dealerUsers.length){
        this.dealerUsers.forEach(element => {
          if(solarRoleIds.includes(element.authlevel)){
            newFilteredData.push(element);
          }
        });
      }

      if(val){ this.dealerUsers = newFilteredData; }
      else { this.dealerUsers = this.originalDealersData; }
      this.solarSwitch = {
        value: val,
        disable: false,
        loading: false
      };
      this.filteredDealerUsers = this.dealerUsers
    },
    getTextBasedOnRoles,
    decodeHtml,
    changeTab(tabnumber){
      this.activeTab = tabnumber;
      if(tabnumber) this.filteredDealerUsers = this.dealerUsers 
    },
    chooseDefaultsFromURL(){
      if(this.$route.params.centerLoc){
        let loc = centerLocations.find(e => e.name === this.$route.params.centerLoc);
        this.mapCentered = loc ? loc : centerLocations[0];
      } else {
        this.mapCentered = centerLocations[0];
      }
    },
    getOnlyDate (date) {
      return date ? moment(date).format("DD/MM-YYYY") : "";
    },
    async fetchEmployeesList(token) {
      let data = await GlobalService.getEmployeesList(token);
      if (data.employees) {
        this.employeesData = data.employees
        // this.employeesData = data.employees.map(item => item.name);
      }
    },
    async fetchUserSystems(token) {
      let data = await GlobalService.getDealerSystems(token);
      if (data.systems) {
        this.systemData = data.systems;
        this.filteredData = data.systems;
      }
      if (this.systemData && this.systemData.length) {
        this.center = L.latLng(this.systemData[0].system.geolat, this.systemData[0].system.geolng);
      }
    },
    async fetchDashboardInfo(token){
      this.dealerDashbaord = await GlobalService.getDealerDashboard(token);
    },
    async fetchDealersInfo(token){
      let data = await GlobalService.getdealerinfo(token);
      if (data.dealer ) {
        this.dealersData = data.dealer;
        this.fetchDealerUsers(token);
      }
    },
    async fetchDealerUsers(token){
      let data = await GlobalService.getAdminDealers(token);
      if (data.systems ) {
        this.originalDealersData = data.systems.filter(item => item.active === "1");
        this.dealerUsers = data.systems.filter(item => item.active === "1");
        this.filteredDealerUsers = data.systems.filter(item => item.active === "1");
      }
      if(this.$route.params.solar === 'solar') {
        this.filterSolarUsers(true)
        document.getElementById('input-17').setAttribute('value', true)
      }
    },
    markerClicked(box) {
      this.systemItem = box;
      this.openInfoModal = true;
      this.infoModalKey += 1;
      /* router.push("/event-logs"); */
    },
    dealerMarkerClicked(item){
      this.dealerItem = item;
      this.openDealerInfoModal = true;
    },
    findMonthsForService(item){
      if(item.lastservice){
        let monthDifference =  moment(new Date()).diff(new Date(item.lastservice), 'months', true);
        if(monthDifference <= 9){
          return "no"
        } else if(monthDifference <= 12){
          return "soon"
        } else if(monthDifference > 12){
          return "due"
        }
      }
    },
    async assignEmployee(item){
      let data = await GlobalService.assignEmployeeToSystem(this.adminToken, item.id, item.employee.id);
      if (data.status !== 0) {
        this.fetchUserSystems(this.adminToken);
      }
    },
    async applyFilters(conditions){
      let data1 = this.systemData;
      let data2 = this.systemData;
      let data3 = this.systemData;
      let userTypeFilteredData = this.dealerUsers;
      if(conditions.employee || conditions.service || conditions.state){
        if(conditions.employee){
          data1 = await this.systemData.filter(a =>{
            if(a.system.employee === conditions.employee.id){
              return 1;
            }
          })
          this.filteredData = data1;
        }
        if(conditions.service){
          data2 = await data1.filter(a =>{
            if(this.findMonthsForService(a.system) === conditions.service){
              return 1;
            }
          })
          this.filteredData = data2;
        }
        if(conditions.state){
          data3 = await data2.filter(a =>{
            if(a.system.sysstate === conditions.state){
              return 1;
            }
          })
          this.filteredData = data3;
        }
      } else {
        this.filteredData = this.systemData;
      }

      if(conditions.userType){
        userTypeFilteredData = await this.dealerUsers.filter(a =>{
          if(a.authlevel === conditions.userType){
            return 1;
          }
        })
        this.filteredDealerUsers = userTypeFilteredData;
      } else {
        this.filteredDealerUsers = this.dealerUsers;
      }
    },
    selectedUserFromMap(dealerItem){
      this.searchUser = "";
      this.activeTab = 1;
      this.filteredDealerUsers = [dealerItem];
    },
    closeInfoModalFunc(){
      this.openInfoModal = false;
    },
    closeDealerInfoModalFunc(){
      this.openDealerInfoModal = false
    },
    closeAddSystemModalFunc(){
      this.openAddSystemModal = false
    },
    closeFiltersModalFunc(){
      this.openFiltersModal = false;
    },
    closeEditUserModalFunc(){
      this.openEditUserModal = false;
    },
    closeAlterServiceDateFunc(){
      this.openAlterDateModal = false
    },
    closeAssignItselfModalFunc(){
      this.openAssignItselfToggle = false;
    },
    closeEventsModalFunc(){
      this.openEventsModal = false;
    }
  }
};
</script>
<style scoped>
.status-0 {
  background-color: rgb(130,225,147)
}
.status-1 {
  background-color: rgb(225,128,128)
}
.status-other {
  background-color: rgb(223,217,217)
}
.home-page {
  height: 100%;
}
.d-menu-bar {
  display: flex;
  align-items: center;
  justify-content: center;
}
.floating-button-container {
  position: absolute;
  top: 3rem;
  right: 3rem;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: flex-end;
}
.floating-button-container .v-btn {
  margin-bottom: 0.5rem;
}
.alert-on-map {
  position: absolute !important;
  right: 20px;
  z-index: 9999;
  bottom: 0;
}
.map-container {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.v-card {
  box-shadow: 0px 0px 0px 0px !important;
}
.map-height {
  height: calc(100vh - 80px);
}
.v-tabs {
  flex: 0 !important;
}
.dropdown-style {
  min-width: 200px;
  font-size: 12px;
}
.user-selection-div {
  display: flex;
  align-items: center;
  margin: 5px 10px;
}
.user-selection-div div {
  min-width: 16px;
  position: relative;
  top: 1px;
}
.dropdown-list-item {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.search-filter-form{
  padding:20px;
}
.search-filter{
  background: #fff;
  background: #fff;
  padding: 10px;
  width: 100%;
}
.switch-fixed{
  position: absolute;
  top: 83px;
  left: 10px;
  z-index: 9;
}
@media only screen and (max-width: 768px){
  .map-height {
    height: calc(100vh - 65px);
  }
  .switch-fixed{
    position: static;
  }
}
</style>
